/**
 * Token Stats Component
 * Shows token usage and compacting status
 */

import { useConversationCompactor } from '../hooks/useConversationCompactor';

export function TokenStats({ onCompact }) {
  const { getCurrentStats, compactIfNeeded, isAvailable } = useConversationCompactor();

  if (!isAvailable) return null;

  const stats = getCurrentStats();
  if (!stats) return null;

  const { tokens, maxTokens, percentUsed, needsCompacting, remainingTokens } = stats;

  const getFillClass = () => {
    if (percentUsed > 80) return 'danger';
    if (percentUsed > 60) return 'warning';
    return '';
  };

  const handleCompact = async () => {
    const result = await compactIfNeeded((msg) => {
      if (onCompact) onCompact(msg);
    });

    if (result.compacted && onCompact) {
      onCompact(`✅ Compacted! Saved ${result.stats.percentSaved}% tokens`);
    }
  };

  return (
    <div className="token-stats">
      <div className="stat">
        <span className="stat-label">Tokens:</span>
        <span className="stat-value">{tokens.toLocaleString()}</span>
        <span className="stat-label">/ {maxTokens.toLocaleString()}</span>
      </div>

      <div className="progress-bar">
        <div
          className={`progress-fill ${getFillClass()}`}
          style={{ width: `${percentUsed}%` }}
        />
      </div>

      <div className="stat">
        <span className="stat-value">{percentUsed}%</span>
      </div>

      {needsCompacting && (
        <button onClick={handleCompact} className="compact-btn">
          Compact Now
        </button>
      )}
    </div>
  );
}

export default TokenStats;
